import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import withReducer from 'app/store/withReducer';
import reducer from 'app/store/notifications';
import serviceWorkerPush from 'app/../serviceWorkerPush';
import { selectNotifications } from 'app/store/notifications/notificationsSlice';
import { initConnection } from 'app/store/notifications/notificationsHubSlice';
import { getExistingSubscription } from 'app/store/notifications/pushSubscriptionSlice';
import { useUserData } from 'app/main/components';

const pushNotificationSupported = serviceWorkerPush.isSupported();

function NotificationsProvider({ children }: { children: React.ReactNode }) {
	const dispatch = useDispatch<any>();
	const userData = useUserData();

	const notifications = useSelector(selectNotifications);

	// Initialize the connection with middlewhere signalR hub
	React.useEffect(() => {
		if (userData.user_uid != null) {
			dispatch(initConnection());
		}
	}, [dispatch, userData.user_uid]);

	// Update the favicon to show the notification badge
	React.useEffect(() => {
		const linkElement = document.getElementById('favicon') as HTMLImageElement;
		if (linkElement !== null) {
			if (notifications?.length === 0) {
				linkElement.src = '/logo-192x192.png';
			} else {
				linkElement.src = '/logo-192x192-badge.png';
			}
		}
	}, [notifications?.length]);

	// Register the push service worker
	React.useEffect(() => {
		if (pushNotificationSupported) {
			serviceWorkerPush.registerServiceWorker().then(() => {
				if (import.meta.env.DEV) console.log('[Push SW] Service registered');
				dispatch(getExistingSubscription());
			});
		}
	}, [dispatch]);

	return children;
}

export default withReducer('notifications', reducer)(NotificationsProvider);
